import { ERROR_CODES } from '@/consts';

export default class LogCannotRemove extends Error {
  static code = ERROR_CODES.CASH_LOG_CANNOT_REMOVE;

  constructor(message) {
    super(message || 'This transaction cannot removed because it in range closure.');
    this.code = ERROR_CODES.CASH_LOG_CANNOT_REMOVE;
  }
}
